import { useState, useEffect, useRef } from 'react';

function useComponentVisible(
  initialIsVisible,
  selfClick = false,
  self = null,
  disabled,
  extraBlockId
) {
  const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
  const ref = useRef(null);

  const handleClickOutside = event => {
    if (!ref.current || disabled) {
      return;
    }
    if (selfClick) {
      const extraBlock = document.getElementById(extraBlockId);
      if (
        extraBlock &&
        [...extraBlock.getElementsByTagName('*')].includes(event.target)
      ) {
        return;
      }
      if ([...ref.current.getElementsByTagName('*')].includes(event.target)) {
        const isSelf =
          [...ref.current.getElementsByClassName(self)].includes(event.target) &&
          isComponentVisible;
        const isInsideSelf =
          [
            ...[...ref.current.getElementsByClassName(self)].map(x => [
              ...x.getElementsByTagName('*')
            ])
          ]
            .flat(1)
            .includes(event.target) && isComponentVisible;
        if (isSelf || isInsideSelf) {
          setIsComponentVisible(false);
        } else {
          setIsComponentVisible(true);
        }
      } else {
        setIsComponentVisible(false);
      }
      return;
    }
    if (ref.current && !ref.current.contains(event.target)) {
      setIsComponentVisible(false);
    } else {
      setIsComponentVisible(!isComponentVisible);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  return { ref, isComponentVisible, setIsComponentVisible };
}

export default useComponentVisible;
